import { Box, TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { useAddNotificationMutation } from 'features/userNotifications';
import { useUploadImageMutation } from 'features/uploadImageNotifications/api/uploadImage';
import { ImageUpload } from 'shared/ui/ImageUpload/ui/ImageUpload';
import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';

const actionTypes = [
  {
    label: 'Внешняя ссылка',
    value: 'external_link',
  },
  {
    label: 'Диплинк',
    value: 'deep_link',
  },
];

type FormDataType = {
  title: string;
  content: string;
  action_button: { label?: string; url: string; action_type: string };
  image_guid: string | undefined;
};

type PropsType = { id: string; app_type: string };

export const SendPersonalNotification = ({ id, app_type }: PropsType) => {
  const dispatch = useAppDispatch();
  const [addNotification] = useAddNotificationMutation();
  const [uploadFunc, uploadProps] = useUploadImageMutation();

  const {
    control,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<FormDataType>();

  useEffect(() => {
    if (uploadProps.data && uploadProps.isSuccess) {
      // @ts-ignore
      setValue('image_guid', uploadProps?.data);
    }
  }, [uploadProps.isSuccess]);

  const onFormSubmit = async () => {
    const data = getValues();
    if (!data.title) {
      setError('title', { type: 'custom' });
      return;
    }

    clearErrors();

    const notificationBtnLabelIsExist = !!data.action_button.label;

    const res = await addNotification({
      id,
      data: { ...data, action_button: notificationBtnLabelIsExist ? data.action_button : null, app_type },
    });
    // @ts-ignore
    if (res && res?.data) {
      dispatch(setDrawerOpen(false));
    }
  };

  const uploadImage = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    uploadFunc(formData);
  };

  return (
    <Box component="form">
      <Controller
        name="title"
        control={control}
        render={({ field }) => (
          <TextField
            error={!!errors?.title}
            helperText={!!errors?.title && 'Заголовок не может быть пустым'}
            label="Заголовок уведомления"
            fullWidth
            sx={{ marginBottom: '24px' }}
            {...field}
          />
        )}
      />

      <Controller
        name="content"
        control={control}
        render={({ field }) => (
          <TextField
            multiline
            label="Содержание уведомления"
            fullWidth
            rows={3}
            sx={{ marginBottom: '24px' }}
            {...field}
          />
        )}
      />

      <Controller
        name="action_button.label"
        control={control}
        render={({ field }) => (
          <TextField
            label="Названия кнопки"
            fullWidth
            sx={{ marginBottom: '24px' }}
            {...field}
          />
        )}
      />

      <Controller
        name="action_button.url"
        control={control}
        render={({ field }) => (
          <TextField
            label="URL"
            fullWidth
            sx={{ marginBottom: '24px' }}
            {...field}
          />
        )}
      />

      <Controller
        control={control}
        name="action_button.action_type"
        rules={{ required: 'Необходимо выбрать тип ссылки' }}
        render={({ field }) => (
          <FormControl
            fullWidth
            sx={{ marginBottom: '24px' }}
          >
            <InputLabel id="select-label-type">Тип ссылки</InputLabel>
            <Select
              labelId="select-label-type"
              label="Тип ссылки"
              {...field}
            >
              {actionTypes.map((actionType) => (
                <MenuItem
                  key={actionType.value}
                  value={actionType.value}
                >
                  {actionType.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />

      <ImageUpload
        callback={uploadImage}
        isLoading={uploadProps.isLoading}
        isSuccess={uploadProps.isSuccess}
        silent
      />

      <Button
        variant="contained"
        onClick={onFormSubmit}
        sx={{ textTransform: 'none' }}
      >
        Отправить
      </Button>
    </Box>
  );
};
